// 我的投资成交确认书详情
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">成交确认书</div>
      <div>
        <div v-for="(item, index) in list " :key="index">
          <div v-if="urlCheck(item.fileUrl) == 'pdf'" >
            <iframe width="100%" height="1650px" @click="previewLook(item.fileUrl)" :src="item.fileUrl" class="el-image"></iframe>
            <div class="small-tip" @click="previewLook(item.fileUrl)">预览</div>
          </div>
          <div class="demo-image__preview" v-else>
            <el-image :lazy="true" :src="item.fileUrl" :preview-src-list="[item.fileUrl]"> </el-image>
            <div class="small-tip">预览</div>
          </div>
        </div>
      </div>
      <div class="btn_wrap" style="margin: 40px 0">
        <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue'
import HeaderImg from "@/components/HeaderImg";
export default {
  name:'sureBook',
  components: {
    ChooseSearch,
    HeaderImg,
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "我的投资", path: "/myInvest" },
        { name: "确认书详情", path: "/myInvest" },
      ],
      list: [],
      fileTypeInChild: ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
     urlCheck(url){
      let index = url.lastIndexOf(".");
      return url.substr(index+1);
    },
    async getList() {
      await this.$api.my.getConfirmFile({ listingApplyId:this.$route.query.id,}).then((res) => {
          if (res.code == 1000 && res.data && res.data.confirmFile) {
            this.list = res.data.confirmFile
            // this.list.push({ fileUrl:'http://kf.vpclub.cn/dev/file/group1/M00/00/96/rBB9DGAzebGAFX75ACJNclFHFk8318.pdf'})
          }
        })
    },
    previewLook(fileUrl){
      if(this.urlCheck(fileUrl) == 'pdf'){
        window.open(fileUrl, "_blank");
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.small-tip{
  font-size: 14px;
  color: #a7a8aa;
  margin: 10px auto;
  text-align: center;
}
.flex-auto{
  display: flex;
  align-items: center;
  justify-content: center;
  >div{
    overflow: hidden;
    margin: 20px;
    width:100%;
  }
  .el-image{
    //height:200px;
  }
}
</style>
